import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

const galerias = [
  {
    titulo: " Galería – Día de la Mujer",
    carpeta: "/galeria/dia-de-la-mujer/",
    cantidad: 7,
  },
  {
    titulo: " Galería – Previa Día de la Madre",
    carpeta: "/galeria/dia-de-la-madre/",
    cantidad: 12,
  },
   {
    titulo: " Galería – 1er Partido Playoffs vs Obras",
    carpeta: "/galeria/obras1/",
    cantidad: 8,
  },
  {
    titulo: "Galeria - 2do Partido PLayoffs vs Obras ",
    carpeta: "/galeria/obras2/"
  
  }
];

export default function Galeria() {
  return (
    <div className="bg-gray-100 min-h-screen p-6">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold text-blue-700 mb-6 uppercase"> Galería de Eventos</h2>

        {galerias.map((galeria, idx) => (
          <div key={idx} className="mb-10">
            <h3 className="text-2xl font-semibold text-gray-800 mb-4">{galeria.titulo}</h3>
            <Carousel
              showThumbs={false}
              infiniteLoop
              autoPlay
              showStatus={false}
              className="rounded-xl shadow"
            >
              {Array.from({ length: galeria.cantidad }).map((_, i) => (
                <div key={i}>
                  <img
                    src={`${galeria.carpeta}${i + 1}.jpg`}
                    alt={`${galeria.titulo} ${i + 1}`}
                    className="object-cover h-[500px] w-full rounded-xl"
                  />
                </div>
              ))}
            </Carousel>
          </div>
        ))}
      </div>
    </div>
  );
}
